import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchMedicalConsent = async (uhid_no) => {
  const response = await axios.get(`${API_BASE_URL}/get_medical_consent/${uhid_no}`);
  return response.data;
};

export const fetchPatientData = async (uhid_no) => {
  const response = await axios.get(`${API_BASE_URL}/get_patient/${uhid_no}`);
  return response.data;
};

export const fetchMedicalNextIp = async () => {
  const response = await axios.get(`${API_BASE_URL}/medical_next_ip`);
  return response.data;
};

export const submitMedicalConsent = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/submit_medical_consent`, data, { withCredentials: true });
  return response.data;
};

export const updateMedicalConsent = async (uhid_no, data) => {
  const response = await axios.put(`${API_BASE_URL}/update_medical_consent/${uhid_no}`, data, { withCredentials: true });
  return response.data;
};

export const generateMedicalShareToken = async (uhid_no) => {
  const response = await axios.post(`${API_BASE_URL}/generate_for_medical_consent_share_token/${uhid_no}`);
  return response.data;
};
